import { createContext, type ReactNode, useContext } from 'react';

import type { PageWidth } from './PageLayout';

const PageWidthContext = createContext<PageWidth>('capped');

interface PageWidthProviderProps {
    /** The width every `PageLayout` below uses when it does not set `width` itself. */
    width: PageWidth;
    children?: ReactNode;
}

/** Sets the default `PageLayout` width for a whole section of the app, e.g. `/internal`. */
export function PageWidthProvider(props: PageWidthProviderProps) {
    return <PageWidthContext value={props.width}>{props.children}</PageWidthContext>;
}

export function useDefaultPageWidth(): PageWidth {
    return useContext(PageWidthContext);
}
